"use strict";
/*
 * Membrane React package
 * {@link https://www.npmjs.com/package/@membranehq/react}
 * v0.29.2
 */
'use client';

const preventFocusShift = (e) => {
  e.preventDefault();
};

export { preventFocusShift };
